'use strict';

var setDateChainableConstructor = require('../internal/setDateChainableConstructor');

setDateChainableConstructor();


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/build/setDateChainableConstructorCall.js
// module id = 481
// module chunks = 0